module.exports = __webpack_public_path__ + "static/media/thumbnail.5826742f.jpg";